import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { RADIOBUTTON_DATA_KEYS, RADIOBUTTON_DATA_HOOKS } from './dataHooks';

export interface RadioButtonDriver extends BaseUniDriver {
  isChecked(): Promise<boolean>;
  isDisabled(): Promise<boolean>;
  isFocused(): Promise<boolean>;
  isRequired(): Promise<boolean>;
  clickInput(): Promise<void>;
  getInput(): Promise<HTMLInputElement>;
  getSubtextText(): Promise<string>;
  getLang(): Promise<string>;
}

export const radioButtonDriverFactory = (
  base: UniDriver,
): RadioButtonDriver => {
  return {
    ...baseUniDriverFactory(base),
    async getInput() {
      return base.$('input').getNative();
    },
    async clickInput() {
      return base.$('input').click();
    },
    async isChecked() {
      return (await base.attr(RADIOBUTTON_DATA_KEYS.Checked)) === 'true';
    },
    async isDisabled() {
      return (await base.attr(RADIOBUTTON_DATA_KEYS.Disabled)) === 'true';
    },
    async isFocused() {
      return (await base.attr(RADIOBUTTON_DATA_KEYS.Focused)) === 'true';
    },
    async isRequired() {
      return (await base.attr(RADIOBUTTON_DATA_KEYS.Required)) === 'true';
    },
    async getLang() {
      return base.attr('lang');
    },
    async getSubtextText() {
      return base
        .$(`[data-hook="${RADIOBUTTON_DATA_HOOKS.SubtextWrapper}"]`)
        .text();
    },
  };
};
